import { geocodingRequest } from "./geocodingRequest";

export default geocodingRequest;
